// API configuration
const API_CONFIG = {
  // Base URL for API requests, falling back to localhost if environment variable is not set
  BASE_URL: (process.env.REACT_APP_API_URL as string) || 'http://localhost:8000',

  // API version path
  API_VERSION: '',

  // Full API base URL with version
  get BASE_URL_WITH_VERSION() {
    return `${this.BASE_URL}${this.API_VERSION}`;
  },
};

export default API_CONFIG;
